module.exports = __webpack_public_path__ + "img/admin.4361702c.svg";